import { Expose } from "@nts/std/serialization";
import { ServiceRequest } from './service-request';
import { StoreRequestInterface } from "@nts/std/interfaces";

export class StoreRequest<TModel> extends ServiceRequest implements StoreRequestInterface<TModel> {

  @Expose()
  model: TModel;
}
